/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GroupRoleUpdateData from './GroupRoleUpdateData';

/**
 * The SystemControllerDtoGroupRoleUpdateRequest model module.
 * @module model/SystemControllerDtoGroupRoleUpdateRequest
 * @version 1.0
 */
class SystemControllerDtoGroupRoleUpdateRequest {
    /**
     * Constructs a new <code>SystemControllerDtoGroupRoleUpdateRequest</code>.
     * @alias module:model/SystemControllerDtoGroupRoleUpdateRequest
     */
    constructor() { 
        
        SystemControllerDtoGroupRoleUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoGroupRoleUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoGroupRoleUpdateRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoGroupRoleUpdateRequest} The populated <code>SystemControllerDtoGroupRoleUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoGroupRoleUpdateRequest();

            if (data.hasOwnProperty('list')) {
                obj['list'] = ApiClient.convertToType(data['list'], [GroupRoleUpdateData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoGroupRoleUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoGroupRoleUpdateRequest</code>.
     */
    static validateJSON(data) {
        if (data['list']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['list'])) {
                throw new Error("Expected the field `list` to be an array in the JSON data but got " + data['list']);
            }
            // validate the optional field `list` (array)
            for (const item of data['list']) {
                GroupRoleUpdateData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/GroupRoleUpdateData>} list
 */
SystemControllerDtoGroupRoleUpdateRequest.prototype['list'] = undefined;






export default SystemControllerDtoGroupRoleUpdateRequest;

